import { SelectOption } from 'global';
import { DealerLocationOptionsResponse } from '../api/types';

export function normalizeDealerLocations(locationsResponse: DealerLocationOptionsResponse | undefined) {
  if (!locationsResponse) return [];

  return locationsResponse.dealerLocationsOptions.locations.reduce<SelectOption[]>((acc, location) => {
    acc.push({ value: location.value, label: location.label });

    if (location.childrenLocation) {
      location.childrenLocation.forEach(childrenLocation => {
        acc.push({ value: childrenLocation.value, label: childrenLocation.label });
      });
    }
    return acc;
  }, []);
}
